import {
  Period,
  type RealityCheckLimitItem,
  realityCheckLimits,
} from 'utils/types';

const millisecondsToPeriodMap = new Map<string, Period>([
  ['60000', Period.MINUTE_1],
  ['300000', Period.MINUTE_5],
  ['600000', Period.MINUTE_10],
  ['1200000', Period.MINUTE_20],
  ['1800000', Period.MINUTE_30],
  ['3600000', Period.HOUR_1],
  ['7200000', Period.HOUR_2],
  ['14400000', Period.HOUR_4],
  ['21600000', Period.HOUR_6],
]);

export const getLimitFromMilliseconds = (
  milliseconds: string | undefined,
): RealityCheckLimitItem => {
  const period =
    millisecondsToPeriodMap.get(milliseconds ?? '') ?? Period.NEVER;
  return realityCheckLimits[period];
};
